import styled from 'styled-components';

type SidebarBadgeProps = {
  variant?: 'default' | 'absolute';
};

/**
 * Shared badge component for sidebar items
 * Ensures consistent styling across all sidebar badges (counts, labels, etc.)
 *
 * @variant default - Inline badge for use within flex layouts
 * @variant absolute - Absolutely positioned badge (for legacy compatibility with LinkBadge/CategoryBadge)
 */
const SidebarBadge = styled.span<SidebarBadgeProps>`
  font-size: 0.625rem;
  font-weight: 600;
  color: ${(props) =>
    props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.6)'};
  background: ${(props) =>
    props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
  border: 1px solid
    ${(props) =>
      props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)'};
  padding: 1px 5px;
  border-radius: 8px;
  min-width: 18px;
  text-align: center;
  flex-shrink: 0;
  line-height: 1.2;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  /* Absolute positioning variant for LinkBadge/CategoryBadge */
  ${(props) =>
    props.variant === 'absolute' &&
    `
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  `}

  /* Active state styling (when parent has .active class) */
  .active & {
    color: ${(props) => props.theme.palette.primary.main};
    background: ${(props) =>
      props.theme.palette.mode === 'dark' ? 'rgba(251, 140, 0, 0.1)' : 'rgba(251, 140, 0, 0.08)'};
    border-color: ${(props) => props.theme.palette.primary.main};
    font-weight: 700;
  }

  /* Hover state for parent */
  *:hover > & {
    color: ${(props) => props.theme.palette.text.primary};
    border-color: ${(props) =>
      props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.25)'};
  }
`;

export default SidebarBadge;
